import React, { FC } from 'react';
import Map from "./Map"
import cn from "classnames"

import "leaflet-contextmenu";
import "leaflet-contextmenu/dist/leaflet.contextmenu.css";
import '@szhsin/react-menu/dist/index.css';
import '@geoman-io/leaflet-geoman-free';
import '@geoman-io/leaflet-geoman-free/dist/leaflet-geoman.css';

import st from "./map.module.scss";
import MapTools from "@modules/map/tools/MapTools";
import { LoggerLevel, LoggerFactory } from '@infobis/as-logger';
import { useTypedSelector } from "@hooks/useTypedSelector";


export enum ModeEnum {
    BASE = "BASE",
    POLYGON_EDITOR = "POLYGON_EDITOR",
    MISSION_EDITOR = "MISSION_EDITOR"
}

type IMaperContainer = {
    activeArea?: any //---нужно для сдвига центра карты без сдвига карты(not used)
}

const log = LoggerFactory.getLogger("map.container").setLevel(LoggerLevel.INFO)
//==========================================++>
const MapContainer: FC<IMaperContainer> = (props: IMaperContainer) => {

    let {} = props

    const operations = useTypedSelector(state => state.operations)

    return (
        <div className={cn(st.map)}>
            <Map/>
            <MapTools/>
        </div>
    )
}
export default MapContainer;